import { useState } from "react";
import InputField from "./inputField";
import stepIconOrange from "@assets/icons/Step-icon-base-orange.svg";
import stepIconGray from "@assets/icons/Step-icon-base.svg";
import tickIcon from "@assets/icons/tick-circle-orange.svg";
import arrowIcon from "@assets/images/Frame-9.svg";

import FileUpload from "./FileUpload";

const steps = [
  "Personal Information",
  "Document Uploads",
  "Company Information",
  "Authorized Contact",
];

export default function MultiStepForm() {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    // Handle form submission
    console.log("Form submitted");
  };

  return (
    <div className="w-full min-h-[400px] md:min-h-[500px] lg:min-h-[731px] rounded-[12px] md:rounded-[16px] lg:rounded-[24px] bg-white py-4 md:py-6 lg:py-[64px] px-3 md:px-6 lg:px-[100px]">
      {/* Mobile Step Heading */}
      <div className="md:hidden text-center mb-4">
        <h2 className="text-[16px] font-medium text-[#F03813]">
          {steps[currentStep]}
        </h2>
      </div>

      {/* Step Indicators */}
      <div className="md:flex justify-center hidden  items-center overflow-x-auto pb-3 md:pb-4">
        <div className="flex items-center min-w-max">
          {steps.map((_, index) => (
            <div key={index} className="flex items-center">
              {/* Step Icon */}
              <div className="flex-shrink-0">
                {index < currentStep ? (
                  <img
                    src={tickIcon}
                    alt="Completed"
                    className="w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10"
                  />
                ) : index === currentStep ? (
                  <img
                    src={stepIconOrange}
                    alt="Active"
                    className="w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10"
                  />
                ) : (
                  <img
                    src={stepIconGray}
                    alt="Pending"
                    className="w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10"
                  />
                )}
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <span
                  className={`block h-[1.5px] md:h-[2px] w-8  md:w-[180px] lg:w-[230px] 2xl:w-[280px] ${
                    index < currentStep ? "bg-[#F03813]" : "bg-[#62636C66]"
                  }`}
                ></span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Step Titles */}
      <div className="hidden md:flex w-full items-center justify-center gap-2 md:gap-4 lg:gap-6 mt-2 md:mt-3 lg:mt-[20px] overflow-x-auto">
        <div className="flex items-center w-full justify-between gap-2 md:gap-4 lg:gap-6 xl:gap-[80px] min-w-max px-2">
          {steps.map((step, index) => (
            <p
              key={index}
              className={`text-[8px] md:text-[14px]  xl:text-[20px] font-medium leading-tight text-center ${
                index === currentStep ? "text-[#F03813]" : "text-[#0A0E2EBF]"
              }`}
            >
              {step}
            </p>
          ))}
        </div>
      </div>

      {/* Form Content */}
      <div className="mt-4 md:mt-6 lg:mt-8 xl:mt-12">
        {currentStep === 0 && <PersonalInformationStep />}
        {currentStep === 1 && <DocumentUploadsStep />}
        {currentStep === 2 && <CompanyInformationStep />}
        {currentStep === 3 && <AuthorizedContactStep />}

        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4 pt-6 md:pt-8 lg:pt-10">
          {currentStep > 0 && (
            <button
              onClick={handleBack}
              className="w-full sm:w-auto px-4 md:px-5 lg:px-6 py-3 md:py-4 text-[14px] md:text-[16px] lg:text-lg rounded-full flex items-center justify-center gap-2 md:gap-2.5 bg-[#62636C66] text-[#0A0E2EBF] flex-shrink-0 hover:bg-[#62636C80] transition-colors order-2 sm:order-1"
            >
              <img
                src={arrowIcon}
                alt="arrow icon"
                className="transition-all duration-300 w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 -rotate-90"
              />
              Back
            </button>
          )}
          <div className="w-full sm:w-auto sm:order-2 order-1">
            {currentStep < steps.length - 1 ? (
              <button
                onClick={handleNext}
                className={`w-full sm:w-auto px-4 md:px-4 py-3 md:py-[17.5px] text-xs md:text-lg rounded-full justify-center flex items-center gap-2.5 bg-[#090D2C] text-white flex-shrink-0 `}
              >
                Continue
                <img
                  src={arrowIcon}
                  alt="arrow icon"
                  className="transition-all duration-300 size-8 md:size-10"
                />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className={`w-full sm:w-auto px-4 md:px-4 py-3 md:py-[17.5px] text-xs md:text-lg rounded-full justify-center flex items-center gap-2.5 bg-[#090D2C] text-white flex-shrink-0 `}
              >
                Submit Request
                <img
                  src={arrowIcon}
                  alt="arrow icon"
                  className="transition-all duration-300 size-8 md:size-10"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
// Step 1: Personal Information
function PersonalInformationStep() {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField label="Full Name" placeholder="Enter your full name" />
        <InputField
          label="Email Address"
          placeholder="Enter your email address"
          type="email"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Organization"
          placeholder="Enter your organization name"
        />
        <InputField
          label="Purpose of Request"
          placeholder="Enter the purpose of your request"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Organization"
          placeholder="Enter your organization name"
        />
        <InputField
          label="Purpose of Request"
          placeholder="Enter the purpose of your request"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Vendor Category"
          placeholder="Select vendor category"
          as="select"
          options={[
            {
              label: "Select vendor category",
              value: "Select vendor category",
            },
          ]}
        />
        <InputField
          label="Product / Service Description"
          placeholder="Select product / service description"
          as="select"
          options={[
            {
              label: "Select product / service description",
              value: "Select product / service description",
            },
          ]}
        />
      </div>
    </div>
  );
}

// Step 2: Document Uploads
function DocumentUploadsStep() {
  return (
    <div className="space-y-6 md:space-y-8">
      <h1 className="text-[#62636C] text-[16px] md:text-[20px] lg:text-[24px] font-normal">
        All uploads accept PDF/JPEG/PNG formats.
      </h1>

      <div className="flex flex-col gap-6 md:flex-row">
        <FileUpload
          label="Trade License"
          description="Upload trade license"
          accept=".pdf,.doc,.docx"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
        <FileUpload
          label="Authorized Signatory Documents"
          description="Upload authorized signatory documents"
          accept=".pdf,.doc,.docx, jpeg, png"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <FileUpload
          label="Liability Insurance"
          description="Upload liability insurance"
          accept=".pdf,.doc,.docx"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
        <FileUpload
          label="ISO Certificates (if applicable)"
          description="Upload ISO certificates"
          accept=".pdf,.doc,.docx, jpeg, png"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <FileUpload
          label="Product Datasheets / Compliance Certificates"
          description="Upload product datasheets "
          accept=".pdf,.doc,.docx"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
        <FileUpload
          label="Past Project Portfolio"
          description="Upload past project portfolio"
          accept=".pdf,.doc,.docx, jpeg, png"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <FileUpload
          label="HSE Policy & Procedures"
          description="Upload HSE policy & procedures "
          accept=".pdf,.doc,.docx"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
        <FileUpload
          label="VAT Registration Certificate"
          description="Upload VAT registration certificate"
          accept=".pdf,.doc,.docx, jpeg, png"
          maxSize={10}
          onChange={(file) => console.log(file)}
        />
      </div>
    </div>
  );
}

// Step 3: Company Information
function CompanyInformationStep() {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Company Name"
          placeholder="Enter your company name"
        />
        <InputField
          label="Trade License Number"
          placeholder="Enter your trade license number"
          type="number"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Country of Registration"
          placeholder="Enter your country of registration"
        />
        <InputField
          label="Website (optional)"
          placeholder="Enter your company website"
        />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Office Address"
          placeholder="Enter your office address"
          as="textarea"
        />
      </div>

      <FileUpload
        label="Company Profile Upload (PDF)"
        description="Upload company profile"
        helperText="Click to upload or drag and drop"
        accept=".pdf,.doc,.docx, jpeg, png"
        maxSize={10}
        size="large"
        onChange={(file) => console.log(file)}
      />
    </div>
  );
}

// Step 4: Authorized Contact
function AuthorizedContactStep() {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField label="Full Name" placeholder="Enter full name" />
        <InputField label="Designation" placeholder="Enter designation" />
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <InputField
          label="Email Address"
          placeholder="Enter email address"
          type="email"
        />
        <InputField
          label="Mobile Number"
          placeholder="Enter mobile number"
          type="tel"
        />
      </div>

      <div className="flex items-start gap-2 md:gap-[8px]">
        <input
          type="checkbox"
          id="terms-checkbox"
          className="size-4 md:size-6 lg:size-[28px] appearance-none bg-white border-2 border-[#F03813] rounded-[4px] cursor-pointer checked:bg-[#F03813] checked:border-[#F03813] relative checked:after:content-['✓'] checked:after:absolute checked:after:top-1/2 checked:after:left-1/2 checked:after:transform checked:after:-translate-x-1/2 checked:after:-translate-y-1/2 checked:after:text-white checked:after:text-xs checked:after:font-bold flex-shrink-0 mt-1"
        />
        <label
          htmlFor="terms-checkbox"
          className="text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] font-normal text-[#0A0E2EBF] cursor-pointer leading-relaxed"
        >
          I confirm all information provided is accurate and agree to terms
        </label>
      </div>
    </div>
  );
}
